<template>
  <div class="bestsellers">
    <div class="bestseller-slider">
      <DefTitle :result="1" :center="true">
        <h2>
          {{ result.messages.title }}
        </h2>
      </DefTitle>
      <div class="bestseller-slider__link">
        <DefLinkSecondary :href="result.link.href">
          {{ result.link.name }}
        </DefLinkSecondary>
      </div>
      <DefSwiper :settings="settings" @slideChange="slideChange">
        <SwiperSlide v-for="(item, i) in result.items" :key="i">
          <SliderCard :result="item" />
        </SwiperSlide>
      </DefSwiper>
    </div>
    <div class="bestsellers__banner">
      <DefImg
        :result="banner"
        :max-size-off="false"
        :max-width="screenWidth >= 768 ? 'unset' : '100%'"
      />
    </div>
  </div>
</template>

<script setup>
import { SwiperSlide } from 'swiper/vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefLinkSecondary from '@components/Def/DefLink/DefLinkSecondary.vue';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import { reactive, computed } from 'vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import { screenWidth } from '@use/useDeviceInfo';

const props = defineProps({
  result: {
    type: Object,
  },
});

const settings = {
  slidesPerView: 1,
};

const state = reactive({
  activeIndex: 0,
});

const slideChange = ({ activeIndex }) => {
  state.activeIndex = activeIndex;
};

const banner = computed(() => {
  const defaultBanner = {
    src: '/local/templates/love-you/images/front-end/bestsellers.png',
    alt: 'bestsellers banners',
    width: 700,
    height: 700,
  };

  const productBanner = props?.result?.items?.[state?.activeIndex]?.pictures?.[1];

  if (productBanner) {
    return productBanner;
  }

  return defaultBanner;
});

const sliderWidth = computed(() => `${screenWidth.value}px`);
</script>

<style lang="scss" scoped>
.bestsellers {
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 56px;
  background-color: #fff;
  @include point-md {
    margin-bottom: 80px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  &__banner {
    overflow: hidden;
    background-color: #f7f8f9;
    :deep(.def-img) {
      @include point-md {
        height: 100%;
        max-width: unset;
        width: auto;
      }
    }
  }
  :deep(.def-swiper-button-prev) {
    left: 24px;
  }
  :deep(.def-swiper-button-next) {
    right: 24px;
  }
  :deep(.slider-card) {
    margin: 0 auto;
    max-width: 280px;
    @include point-lg {
      max-width: 332px;
    }
  }
}
.bestseller-slider {
  align-self: center;
  padding: 48px 0;
  @include point-md {
    padding: 40px 0;
  }
  @include point-lg {
    padding: 64px 0;
  }
  :deep(.def-swiper) {
    max-width: v-bind(sliderWidth);
    margin-left: auto;
    margin-right: auto;
    @include point-md {
      max-width: 620px;
    }
  }
  &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    margin: 0 auto 24px;
    @include point-lg {
      margin: 0 auto 40px;
    }
    :deep(.def-link) {
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
